module.exports = __webpack_public_path__ + "static/assets/f33541f52553e00993de696ed1233229.png";